// src/store/plugins/indexedDBPlugin.js
import db from '@/untils/db'

const PERSISTENT_PATHS = ['preload', 'userInfo', 'token', 'permissions','dict']

export default function createIndexedDBPlugin() {
    return store => {
        let initialized = false

        // 创建恢复完成的 Promise
        const restorePromise = new Promise((resolve) => {
            db.loadState().then(persistentState => {
                if (persistentState) {
                    // console.log('📦 从 IndexedDB 恢复数据:', persistentState)

                    // 使用 Vuex 的 replaceState 确保完全替换
                    const newState = {
                        ...store.state,
                        ...persistentState
                    }

                    // 特别处理 preload 模块的合并
                    if (persistentState.preload) {
                        newState.preload = {
                            ...store.state.preload,
                            ...persistentState.preload
                        }
                    }

                    store.replaceState(newState)
                    // console.log('✅ 状态恢复完成')
                }

                initialized = true
                resolve() // 通知恢复完成
            }).catch(error => {
                console.error('❌ 恢复状态失败:', error)
                initialized = true
                resolve() // 即使出错也要继续
            })
        })

        // 挂载到 store 实例上
        store.$restorePromise = restorePromise

        // 状态变化时保存
        store.subscribe((mutation, state) => {
            if (!initialized) return

            clearTimeout(store._saveTimer)
            store._saveTimer = setTimeout(() => {
                const persistentState = {}
                PERSISTENT_PATHS.forEach(path => {
                    const parts = path.split('.')
                    let source = state
                    let target = persistentState

                    for (let i = 0; i < parts.length; i++) {
                        const key = parts[i]
                        if (i === parts.length - 1) {
                            target[key] = source[key]
                        } else {
                            if (!target[key]) target[key] = {}
                            target = target[key]
                            source = source[key] || {}
                        }
                    }
                })

                db.saveState(persistentState).catch(error => {
                    console.error('❌ 保存失败:', error)
                })
            }, 500)
        })

        window.addEventListener('beforeunload', () => {
            const persistentState = {}
            PERSISTENT_PATHS.forEach(path => {
                const parts = path.split('.')
                let source = store.state
                let target = persistentState

                for (let i = 0; i < parts.length; i++) {
                    const key = parts[i]
                    if (i === parts.length - 1) {
                        target[key] = source[key]
                    } else {
                        if (!target[key]) target[key] = {}
                        target = target[key]
                        source = source[key] || {}
                    }
                }
            })

            db.saveState(persistentState).catch(() => {})
        })
    }
}
